import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from './http.service';
import { delay, filter, mergeMap, repeatWhen, retryWhen, take, tap } from 'rxjs/operators';
import { AlarmDict } from '../type/employee.interface';

@Injectable({
  providedIn: 'root'
})
export class DictionaryService {
  update = false;
  alarmDict: BehaviorSubject<AlarmDict[]> = new BehaviorSubject<AlarmDict[]>([]);
  isAccess: boolean;

  constructor(private http: HttpService) {}

  init() {
    if (!this.update) {
      this.alarmDict.pipe(tap(x => {
        x.length || this.updateDictAlarm();
      })); // switchMap если там пустой массив
      this.updateDictAlarm();
      this.update = true;
    }

  }
  updateDictAlarm() {
  }

  reset() {
    this.alarmDict.next([]);
    this.update = false;
  }

}

